import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import {
  renderFieldText,
  renderSelect,
  classNames,
  renderDatePickerWithLabel,
} from "@basecomponent";
import LocaleStrings from "@language";
import Loader from "@loader";
import _ from "lodash";
import moment from "moment";
import { DATE_FORMAT } from "@constant";
const PayCancel = (props) => {
  return (
    <>
      <div className="p-8 space-y-10">
        <div className="bg-white rounded-lg w-full p-6 text-base shadow-md h-90%">
          <div className="flex items-center justify-center">
            <div>Payment Cancelled or Failed</div>
          </div>
        </div>
      </div>
    </>
  );
};

const validate = (values) => {};

const mapStateToProps = (state) => {
  var init = {};
  return {
    session: state.session,
    initialValues: init,
    transactionList: state.transactionList,
    vehicleList: state.vehicleList,
    badgeList: state.badgeList,
    locationList: state.locationList,
    eventData: state.eventData,
    serviceList: state.serviceList,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "CancelForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(PayCancel)
);
